import useAlert from "../../../../../../../use/useAlert";
import {useRef, useState} from "react";
import Body from "../../../../../../../material/skeleton/Body";
import Box from "@mui/material/Box";
import {Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField} from "@mui/material";
import Footer from "../../../../../../../material/skeleton/Footer";
import parameter from "../../../../../../../enum/parameter";
import {CheckCircle} from "@mui/icons-material";
import isNull from "../../../../../../../mixin/isNull";

export default function ({next}) {
    const alert = useAlert();
    const [isSolved, setIsSolved] = useState(null);
    const whyInput = useRef(null);

    const nextStep = () => {
        if (isNull(isSolved)) {
            alert.warning("Veuillez compléter le compte rendu");
            return;
        }

        if (!isSolved && whyInput.current.value.length === 0) {
            alert.warning("Veuillez compléter le compte rendu");
            return;
        }

        next({
            is_solved: isSolved,
            why: whyInput.current?.value ?? null
        });
    }

    return (
        <>
            <Body>
                <Box mt={2} px={2}>
                    <FormControl>
                        <FormLabel id="demo-radio-buttons-group-label">Est ce que le problème est résolu ?</FormLabel>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            onChange={e => setIsSolved(e.target.value === "true")}
                        >
                            <FormControlLabel value="true" control={<Radio data-test="radio-solved-yes"/>} label="OUI"/>
                            <FormControlLabel value="false" control={<Radio/>} label="NON"/>
                        </RadioGroup>
                    </FormControl>
                </Box>
                {
                    !isNull(isSolved) && !isSolved
                        ? (
                            <Box mt={2} px={2}>
                                <TextField
                                    label={"Pourquoi ?"}
                                    fullWidth={true}
                                    multiline={true}
                                    minRows={10}
                                    maxRows={20}
                                    inputRef={whyInput}
                                />
                            </Box>
                        )
                        : null
                }

            </Body>
            <Footer>
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    data-test="button-next-step"
                >
                    Étape suivante
                </Button>
            </Footer>
        </>
    );
}